// extracted by mini-css-extract-plugin
export var endContent = "styles-module--endContent--bVlpz";
export var endSection = "styles-module--endSection--tzJmC";
export var wrapper = "styles-module--wrapper--8kkxy";